import React, {ReactElement} from 'react';
import {UpdateSettingsButton} from 'components/UpdateSettingsButton';
import {Text} from 'components/Text';

export const UpdateBudget = (): ReactElement => {
  return (
    <Text>
      <UpdateSettingsButton />
    </Text>
  );
};
